import { Skeleton } from '@/client/components/ui/skeleton';
import { memo } from 'react';

// Route-level fallbacks (confs/routes.tsx) import from here, which puts this
// module in the entry graph: keep it free of api/store/i18n imports so it
// never drags a page's data graph into the entry bundle.

export const MarketCardSkeleton = memo(() => (
  // min-h keeps the skeleton within a few px of a rendered card (binary
  // ~210px, multi-option ~250px) -- the old short skeleton made every swap-in
  // shove the rest of the page down (CLS, perf 7/23).
  <div className="space-y-3 p-5 w-full mcard-surface rounded-2xl min-h-[240px]">
    <div className="flex items-start gap-3">
      <Skeleton className="size-9 rounded-md flex-shrink-0" />
      <Skeleton className="flex-1 h-9" />
    </div>
    <Skeleton className="w-20 h-4" />
    <Skeleton className="w-full h-10" />
    <div className="flex gap-2">
      <Skeleton className="flex-1 h-9 rounded-md" />
      <Skeleton className="flex-1 h-9 rounded-md" />
    </div>
    <div className="flex items-center justify-between">
      <Skeleton className="w-16 h-3" />
      <Skeleton className="w-24 h-3" />
    </div>
  </div>
));
MarketCardSkeleton.displayName = 'MarketGridCardSkeleton';

type MarketCardListSkeletonProps = { len?: number };

export const MarketCardListSkeleton = ({ len = 1 }: MarketCardListSkeletonProps) => {
  return Array.from({ length: len }).map((_, index) => <MarketCardSkeleton key={`MarketGridCardSkeleton-${index}`} />);
};
